<template>
    <div class="beg-grid justify-content-center container-sm">
        <div class="mb-1">
            <EnergySaveCard
                :faIcon="'fa-light fa-plug-circle-bolt'"
                :unit="'Wh'"
                :autoUnits="'metric'"
                :changeValue="calculation.savedPower"
                :footerText="$t('energySaving')"
                :infoMessage="$t('energySavingDescription')"
             />
        </div>
        <div class="mb-1">
            <EnergySaveCard
                :faIcon="'fa-light fa-sack-dollar'"
                :unit="'€'"
                :changeValue="calculation.savedPower/1000*EnergyCalculation.energyPrice"
                :footerText="$t('costSavings')"
                :autoUnits="'million'"
                :infoMessage="$t('costSavingsDescription', {
                    costsPerPower: EnergyCalculation.energyPrice
                })"
             />
        </div>
        <div class="mb-1">
            <EnergySaveCard 
                :faIcon="'fa-light fa-smog'"
                :changeValue="calculation.savedPower/1000*EnergyCalculation.powerInCo2"
                :unit="'kg'"
                :footerText="$t('co2savings')"
                :autoUnits="'weight'"
                :infoMessage="$t('co2savingsDescription', {
                    co2PerPower: EnergyCalculation.powerInCo2*1000
                })"
            />
        </div>
        <div class="mb-1">
            <EnergySaveCard 
                :faIcon="'fa-light fa-trees'"
                :changeValue="calculation.savedPower/1000*EnergyCalculation.powerInCo2/EnergyCalculation.Co2CompisitionOfTree"
                :footerText="$t('treesCo2')"
                :unit="$t('trees')"
                :autoUnits="'million'"
                :infoMessage="$t('treesCo2Description', {
                    co2binding: EnergyCalculation.Co2CompisitionOfTree
                })"
            />
        </div>

    </div>
    <div class="text-center">
        <span class="infoMessage">{{ $t('infoMessage', {date: localStartDate}) }}</span>      
    </div>
</template>
    
<script setup>
import EnergySaveCard from "./EnergySaveCard.vue"
import {energyCalculationStore} from "@/components/EnergyCalculation"

import fa from "@/begComponents/vendor/fontawesome/js/fontawesome.min.js"
import solid from "@/assets/usedIcons/light"
import custom from "@/begComponents/vendor/fontawesome/js/custom-icons"
import {  /* computed ,*/ nextTick, onMounted, ref } from "vue";
import EnergyCalculation from "./EnergyCalculation/EnergyCalculation"
import * as moment from 'moment-mini-ts'
import { useI18n } from "vue-i18n"
const { locale }= useI18n()
fa
custom
solid

const amountOfSensor = ref(4383)

const localStartDate = ref("")

const calculation = energyCalculationStore();

const paused = ref(false)

function runTime() {
    calculationRun()
    if(paused.value) {
        return
    }
    setTimeout(() => {
       runTime()
    }, 1000) 
}

function calculationRun() {
    calculation.calculateSavings(amountOfSensor.value)
}

onMounted(() => {
    const appFrame = document.getElementById('energyCounter')
    if(appFrame.getAttribute('startDate') != null) {
        calculation.changeDate(appFrame.getAttribute('startDate'))
    } else {
        calculation.changeDate("2023-01-01")
    }
    if(appFrame.getAttribute('energyPrice') != null) {
        calculation.setPrice(appFrame.getAttribute('energyPrice'))
    }
    if(appFrame.getAttribute('energySavingPerSensor') != null) {
        calculation.overwriteSensorSaving(appFrame.getAttribute('energySavingPerSensor'))
    }
    if(appFrame.getAttribute('soldSensorsPerYear') != null) {
        calculation.setSoldSensors(appFrame.getAttribute('soldSensorsPerYear'))
    }
    nextTick(() => {
        switch(locale.value) {
            case 'de':
                localStartDate.value = moment(calculation.startDate).format('DD.MM.YYYY');
                break;
            case 'en':
                localStartDate.value = moment(calculation.startDate).format('DD/MM/YYYY');
                break;
            default:
                localStartDate.value = moment(calculation.startDate).format('DD.MM.YYYY');
                break;

        }
    })
    runTime()
})

/* const getInfoLink = computed(() => {
    switch(locale.value) {
        case 'de':
            return "https://beg-luxomat.com/de"
        case 'en':
            return "https://beg-luxomat.com/en"
        default:
            return "https://beg-luxomat.com/en"
    }
})  */

</script>


<style lang='scss' scoped>
.infoMessage {
    font-size: 0.75em;
    padding: 0px;
    margin: 1px;
    line-height: none;
}

#furtherInfoLink {
    color: red;
    font-weight: 700;
    cursor: pointer;
    text-decoration: none;
}



</style>
  